export const legalCaseTitle = (legalCase, legalCaseTypesIds) => {
  return legalCaseTypesIds?.[legalCase.legal_case_type_id]?.fullName
}

export const tagCountValidator = (selectedTags, _, dis) => {
  return (dis.legalCase.tags.length + selectedTags.length) <= 5
}
